export function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function nameInitials(name: string) {
  return name
    .split(" ")
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
}
